import React from 'react';
import { Result } from 'antd';
import useAdmin from "hooks/useAdmin";

const PremiumWrapper = (props) => {

  const { adminData } = useAdmin();

  const { children } = props;

  const NotFound = () => {
    return (
      <Result
        status="info"
        title="This is a Premium feature"
        subTitle="This feature isn't included in your club's current plan. Upgrade to the Premium package to unlock it."
        />
    );
  }

  return (
    <>
      {adminData.isPremium() ? (
        <>{children}</>
      ) : (
        <NotFound />
      )}
    </>
  )

}

export default PremiumWrapper;
